import { useSelectedMapFilter } from 'Features/Map/useSelectedMapFilter';
import { RadioGroup } from 'evergreen-ui';
import React from 'react';
import { MapFilterOptions, SelectedMapFilter } from './utilts';

export default function MapViewDatasourceFilterSelector() {
  const { selectedMapFilter, onSelectMapFilter } = useSelectedMapFilter();
  const options = React.useMemo(() => {
    return Object.entries(MapFilterOptions).map(([key, value]) => ({ label: value, value: key }));
  }, []);

  return (
    <RadioGroup
      label="Отобразить"
      options={options}
      value={selectedMapFilter}
      onChange={(e) => onSelectMapFilter(e.target.value as SelectedMapFilter)}
    />
  );
}
